import { useState } from 'react';
import TaakAanmeldBox from './TaakAanmeldBox';
import { fullName, formatDateLong } from '../../helperfunctions/helperfunctions';
import { FiMail } from 'react-icons/fi';
import '../../css/activiteitenStyling.css';
import { handleData } from '../../api';


const Taak = (props) => {

    const { taak, activiteit, includeUpdate } = props;
    const { taaknaam, taakomschrijving, dagdeel, contactpersoon } = taak;
    const [showInfo, setShowInfo] = useState(false);

    const handleShowInfo = () => {
        setShowInfo(prevShowInfo => !prevShowInfo);
    }

    const contactNaam = contactpersoon ? fullName(contactpersoon) : "";
    const activiteitDatum = formatDateLong(activiteit.datum);

    const getContactEmail = async() => {
        const data = {
            method: 'GET',
            path: `users/${contactpersoon._id}/email`,
        }
        const result = await handleData(data);
        const email = result.data.data;
        window.location.href = `mailto:${email}?subject=Brinkruiters - vraag over vrijwilligers activiteit&body=Activiteit: ${activiteit.naam} %0d%0aDatum: ${activiteitDatum} %0d%0aVrijwilligerstaak: ${taaknaam}%0d%0a%0d%0a`;
    }

    return (
        <div className="taakContainer">
            <div className='taakHeader'>
                <h3>{taaknaam}</h3>
                {taakomschrijving && <button className='taakInfoButton button small' onClick={handleShowInfo}>Info</button>}
                
            </div>
            {showInfo && <div className='taakOmschrijving'>
                <p>Extra info:</p>
                <p>{taakomschrijving}</p>
            </div> }
            <div className='taakMain'>
                <div>
                    <span className='itemTitle1'>Dagdeel: </span>
                    <span>{dagdeel ? dagdeel : "--"}</span>
                </div>

                <div className='contactpersoon'>

                    {contactNaam
                        ? 
                                <button onClick={getContactEmail} className="contact">
                                    <span className='icon'>
                                        <FiMail />
                                    </span>
                                    <span className='itemTitle1'>Contactpersoon: </span>
                                    <span>{contactNaam}</span>
                                </button>
                        :
                        <>
                            <span className='itemTitle1'>Contactpersoon: </span>
                            <span>--</span>
                        </>
                    }

                </div>
                <div>
                    <TaakAanmeldBox taak={taak} activiteit={activiteit} includeUpdate={includeUpdate} />
                </div>
            </div>
        </div>
    );
}

export default Taak;